<div class="custom-dropdown">
  <div class="selected-option" (click)="toggleDropdown()">{{ selectedOption }}</div>
  <ul *ngIf="toggleDropdownFlag" class="dropdown-list">
    <li *ngFor="let option of options" (click)="selectOption(option)">{{ option }}</li>
  </ul>
</div>
